var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_67525",
    "data-name": "Group 67525",
    transform: "translate(-64 -399)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22431",
    "data-name": "Rectangle 22431",
    width: 24,
    height: 24,
    rx: 12,
    transform: "translate(64 399)",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-user",
    transform: "translate(7.5 405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67478",
    "data-name": "Group 67478",
    transform: "translate(64 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67477",
    "data-name": "Group 67477",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80560",
    "data-name": "Path 80560",
    d: "M131,6a3,3,0,1,0-3-3A3,3,0,0,0,131,6Zm0-5a2,2,0,1,1-2,2A2,2,0,0,1,131,1Z",
    transform: "translate(-126.5 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80561",
    "data-name": "Path 80561",
    d: "M68.5,298.667a4.505,4.505,0,0,0-4.5,4.5.5.5,0,0,0,1,0,3.5,3.5,0,0,1,7,0,.5.5,0,0,0,1,0A4.5,4.5,0,0,0,68.5,298.667Z",
    transform: "translate(-64 -291.667)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.051147b16d82f2c381d988012704ad42.svg";
export { ForwardRef as ReactComponent };